import requisites from './requisites';
import requisitesGroups from './requisites-groups';
import templates from './templates';
import workflows from './workflows';
import nomenclatures from './nomenclatures';
import counters from './counters';
import startedWorkflows from './started-workflows';
import finishedWorkflows from './finished-workflows';

const configuration = {
    namespaced: true,
    modules: {
        requisites,
        requisitesGroups,
        templates,
        workflows,
        nomenclatures,
        counters,
        startedWorkflows,
        finishedWorkflows
    }
}

export default configuration;